"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SortMenu = exports.SortItem = exports.SortButton = void 0;
var _mui = require("@ori-ui/mui");
const SortMenu = exports.SortMenu = (0, _mui.styled)(_mui.Popper)((param)=>{
    let { theme } = param;
    return {
        width: 330,
        backgroundColor: theme.palette.common.white,
        border: "1px solid ".concat(theme.palette.grey[300]),
        borderRadius: theme.shape.borderRadius,
        boxShadow: theme.shadows[4],
        padding: theme.spacing(0),
        zIndex: theme.zIndex.fab
    };
});
const SortItem = exports.SortItem = (0, _mui.styled)(_mui.MenuItem)((param)=>{
    let { theme } = param;
    return {
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: theme.palette.primary.light
        },
        padding: theme.spacing(2, 3)
    };
});
const SortButton = exports.SortButton = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        cursor: 'pointer',
        userSelect: 'none',
        width: 'fit-content',
        gap: theme.spacing(1),
        alignItems: 'center'
    };
});
